export default __webpack_public_path__ + "static/media/Nose_3.2c11c63d.svg";